import { render, staticRenderFns } from "./sixMap.vue?vue&type=template&id=58b8b4e8&"
import script from "./sixMap.vue?vue&type=script&lang=js&"
export * from "./sixMap.vue?vue&type=script&lang=js&"
import style0 from "./sixMap.vue?vue&type=style&index=0&id=58b8b4e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports